import React from 'react';

import ReportsPage from "./ReportsPage";

interface ReportsPageProps {}

const ReportsPageContainer: React.FC<ReportsPageProps> = () => {
    return <ReportsPage />
}

export default ReportsPageContainer;